import axios from '../axios';
import {
  GET_KITCHEN_BY_ZIPCODE_API,
  GET_KITCHENS_API,
  WAITLIST_FOUNDING_MEMBER_API,
  REPORT_UI_BUG_API,
} from '../../global/ApiUrl';

export const getKitchenByZipCode = async (zipcode) => {
  try {
    const response = await axios.get(GET_KITCHEN_BY_ZIPCODE_API, {
      params: {
        zipcode,
      },
    });
    return response;
  } catch (error) {
    console.log('getKitchenByZipCode catch error', error);
  }
};

// PAYLOAD
// KitchenListAPI Will get list of kitchen information ,it taks array of kitchenNames
export const kitchenListAPI = async (payload) => {
  try {
    const response = await axios.post(GET_KITCHENS_API, { kitchenNames: payload });
    return response;
  } catch (error) {
    console.log('GET_KITCHENS_API catch error', error);
    return error;
  }
};

// WaitList Founding Member
export const waitListFoundingApi = async (payload) => {
  try {
    const response = await axios.post(WAITLIST_FOUNDING_MEMBER_API, payload);
    return response;
  } catch (error) {
    console.log('WAITLIST_FOUNDING_MEMBER_API catch error', error);
    return error;
  }
};

// RepotUIbug Api Call
export const reportUiBugApi = async (payload) => {
  try {
    const response = await axios.post(REPORT_UI_BUG_API, payload);
    return response;
  } catch (error) {
    console.log('REPORT_UI_BUG_API catch error', error);
    return error;
  }
};
